/** @file tileTakeImage: a dropped or pasted PNG replaces a Tile tab's canvas, or asks how to fit it. */
import { decodePng } from '@zilo/pose3d-image-io/png/decodePng';
import { webZlibCodec } from '@zilo/pose3d-image-io/zlib/webZlibCodec';
import { tileDrafts } from './tileDrafts';

/**
 * Decodes `file` (PNG); the tile's size replaces the pixels at once (one undo step), another size opens the `fit`
 * prompt (Pad / Scale through the Art fit prompt). Resolves an error message, or null when it was taken.
 */
export async function tileTakeImage(draftKey: string, size: readonly [number, number], file: Blob & { name?: string }): Promise<string | null> {
  let image;
  try {
    image = await decodePng(new Uint8Array(await file.arrayBuffer()), webZlibCodec);
  } catch {
    return `${file.name ?? 'The image'} is not a PNG the editor can read`;
  }
  const drafts = tileDrafts.getState();
  if (image.width !== size[0] || image.height !== size[1]) {
    drafts.setPrompt({ kind: 'fit', key: draftKey, name: file.name ?? 'pasted image', image });
    return null;
  }
  const pixels = image.data;
  drafts.stroke(draftKey);
  drafts.edit(draftKey, (img) => { img.data.set(pixels); return true; });
  return null;
}
